module.exports = __webpack_public_path__ + "img/9788993212204.cc8119c7.jpg";